import styled from 'styled-components';
import { PaginationFooter } from 'ui/paginationFooter';
import { usePaginationContext } from 'utils/contexts/pagination';
import { ListReferenceRow } from './ListReferenceRow';
import { Table, HeaderRow } from './table';
import { useListUsageQueryContext } from '../contexts/ListUsageQueryContext';
import { AUD_INSIGHTS_GRID_COL_COUNT } from '../constants';
import { EmptyState } from './EmptyState';
import { InsightPanel } from '../InsightPanel';

const Wrapper = styled.div`
  grid-column: 1 / span ${AUD_INSIGHTS_GRID_COL_COUNT};
`;

const PaginationWrapper = styled.div`
  margin: 0 -${({ theme }) => theme.spacing.values.plusHalf};
`;

const StyledPaginationFooter = styled(PaginationFooter)`
  && {
    border-top: none;
    padding-top: 0;
  }
`;

const StyledInsightPanel = styled(InsightPanel)`
  overflow: hidden;
`;

export const LIST_REFERENCE_DATA_TEST = 'list-reference-table';

export const ListReferencesTable = () => {
  const { currentPage, pageSize, setCurrentPage, setPageSize } = usePaginationContext();
  const { totalCount, listReferences, modifiersAndCreatorsById } = useListUsageQueryContext();

  return (
    <Wrapper data-test={LIST_REFERENCE_DATA_TEST}>
      <StyledInsightPanel>
        <Table>
          <HeaderRow />
          {!totalCount && <EmptyState />}
          {listReferences.map((listReference, index) => (
            <ListReferenceRow
              listReference={listReference}
              key={`usage: ${listReference.id}- ${listReference.createdAt}`}
              index={index}
              modifiersAndCreatorsById={modifiersAndCreatorsById}
            />
          ))}
        </Table>
      </StyledInsightPanel>
      <PaginationWrapper>
        <StyledPaginationFooter
          currentPage={currentPage}
          itemsPerPage={pageSize}
          numItems={totalCount}
          onUpdate={(event) => {
            setCurrentPage(event.page);
            setPageSize(event.pageSize);
          }}
        />
      </PaginationWrapper>
    </Wrapper>
  );
};
